<template>
    <div>
        <div class="page-header-style">
            <ul class="nav nav-pills">
                <li class="disabled"><h4 style="margin-left:15px; margin:10px" class="text-primary"><b>Carehome Users</em></b></h4></li>


                <li class="pull-right">
                    <router-link :to="{ name: 'pharmacy-carehome-user-edit', params: { carehomeid: çarehomeId}}">
                        Add User
                    </router-link>
                </li>
            </ul>
            <!--<hr style="margin-top:0px" />-->
        </div>
        <br />
        <transition name="fade" :duration="500">
            <div v-show="controller.isLoading" class="row" style="width:100%; position:absolute;text-align:center; vertical-align:central">
                <br /><br /><br />
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </transition>
        <datatable v-show="!controller.isLoading" :columns="columns" :source="getUsers" @selected="recordSelected"></datatable>
    </div>
</template>


<script>
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import { UserDto, UserPermissionDto } from "./../../../dto/Dtos";
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"
    import { UserListController } from "./UserListController"
    export default {
        props: [],
        mounted: function () {
            //var dal = new Dal();
            //var t0 = performance.now();
            //this.isLoading = true;
            //var that = this;
            //dal.GetCarehomes().then(data => {
            //    this.carehomes = data;
            //    this.carehomeLoaded = true;
            //    var t1 = performance.now();
            //    console.log("time diff :", (t1 - t0))
            //    setTimeout(() => {
            //        that.isLoading = false;
            //    }, 500 - (t1 - t0));
            //})
        },
        data: function () {
            var formatDate = Formatter.FormatDate;
            var that = this;
            var controller = new UserListController(this.$root.Carehomes);
            controller.Load(this.$root.Carehomes);

            return {
                controller: controller,
                carehomeLoaded: false,
                isLoading: true,
                carehomes: [],
                columns: [
                    {
                        name: "Carehome", data : "carehomeName"
                    },
                    {
                        name: "Name", render: function (data, type, row) {
                            return (row.firstName || "") + " " + (row.lastName || "")
                        }
                    }
                    , { name: "Email", data: "email" }
                    , { name: "Phone", data: "number" }
                    , { name: "Permission", data: "permissionName" }
                    //, {
                    //    name: "Permissions", render: function (data, type, row) {
                    //        //console.log(row)
                    //        var permissions = row.userPermissions;
                    //        var result = "";
                    //        var first = true;
                    //        for (var permission of permissions) {
                    //            if (permission.permissionId == 3 || permission.permissionId == 5) {
                    //                if (first) {
                    //                    first = false;
                    //                }
                    //                else {
                    //                    result += "<br/>"
                    //                }
                    //                result += (permission.permissionId == 5 ? "Carer" : "Manager") + " : " + that.getCarehomeName(permission.carehomeId);
                    //            }
                    //        }
                    //        return result;
                    //    }
                    //}
                ]
            }
        },
        methods: {
            CreateUser: function (carehomeid) {
                this.$router.push({ name: 'pharmacy-carehome-user-edit', query: { 'carehomeid': this.carehomeid } })
            },
            UpdateUser: function (carehomeid, userid) {
                this.$router.push({ name: 'pharmacy-carehome-user-edit', query: { 'carehomeid': carehomeid, 'userid': userid } })
            },
            getCarehomeName: function (carehomeId) {
                //console.log("Carehomes ", this.carehomes, carehomeId)
                for (var ch of this.carehomes) {
                    if (ch.id == carehomeId) {
                        //console.log("Carehome ----s ", ch)
                        return ch.name;
                    }
                }
                return "";
            },
            //getRecords: function (callback) {
            //    var dal = new Dal();
            //    while (!this.carehomeLoaded) {
            //        setTimeout(()=>{}, 100);
            //    }
            //    dal.GetUsers().then(data => {
            //        var records = { data: data };
            //        callback(records);
            //    });
            //},

            getUsers(callback) {
                //if (!this.carehomeLoaded) {
                //    setTimeout(() => { this.getUsers(callback)}, 200);
                //}
                //else {
                //    var dal = new Dal();
                //    dal.GetUsers().then(data => {
                //        var records = { data: data };
                //        callback(records);
                //    });
                //}

                this.controller.Load().then(data => {
                    console.log("User List", data)
                    var records = { data: data };
                    callback(records);
                });
            },

            //filterCarehomes(users) {
            //    // If this is a carehome user - portal should only show carehomes for which this user has permission as carheome user
            //    console.log(this.$root.IsCarehomeUser, carehomes, this.$root.Carehomes)
            //    if (this.$root.IsCarehomeUser) {
            //        var result = [];
            //        for (var user of users) {
            //            for (var permission of user.userPermissions) {
            //                if (permission.permissionId == 5) {
            //                    if (this.$root.Carehomes.filter(c => c.id === permission.carehomeId)) {

            //                    }
            //                }
            //            }
            //        }
            //        return result;
            //    }
            //    else {
            //        return carehomes;
            //    }
            //},

            recordSelected: function (record) {
                var userid = record.userid;
                var carehomeid = record.carehomeId;

                //for (var ch of record.userPermissions) {
                //    if (ch.carehomeId) {
                //        carehomeid = ch.carehomeId;
                //        break;
                //    }
                //}

                console.log("User Selected", userid, carehomeid)
                this.UpdateUser(carehomeid, userid);
                //this.$router.push({ name: 'pharmacy-carehome-user-edit', query: { 'carehomeid': carehomeid, 'userid': userid } })
            }
        },
        components: {
            datatable,
            Formatter
        }
    }
</script>


// WEBPACK FOOTER //
// user-list.scp.html?31319682